export default __webpack_public_path__ + "static/media/SIW500G_W00.a10df9d1.webp";